import React from 'react'
import { makeStyles, Grid, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   formContainer: {
      margin: theme.spacing(2, 2, 1),
   },
   formTitle: {
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   },
   form: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      maxWidth: '600px'
   }
}))

function FormContainer({ onSubmit, children }) {
   const classes = useStyles()
   return (
      <Grid className={classes.formContainer}>
         <Typography className={classes.formTitle}>
            <b> Completa los campos </b>{' '}
         </Typography>
         <form className={classes.form} onSubmit={onSubmit}>{children}</form>
      </Grid>
   )
}

export default FormContainer
1
